import axios from "axios";
import { useEffect, useState } from "react";

const TrackList = ({ albumData, gotoEdit }) => {
	const [state, setState] = useState({
		imagePath: "",
		price: "",
		size: 0,
		core: [],
		embed: [],
		other: [],
	});

	useEffect(() => {
		window
			.$("#accordion1")
			.on("show.bs.collapse", function (e) {
				window.$(e.target).prev(".dextra-collapse-heading").addClass("active");
			})
			.on("hide.bs.collapse", function (e) {
				window
					.$(e.target)
					.prev(".dextra-collapse-heading")
					.removeClass("active");
			});
		if (albumData) {
			let temp = albumData.artwork_images[0];
			setState((oldState) => ({
				...oldState,
				imagePath: axios.defaults.baseURL + temp.path + temp.name,
				price: albumData.price,
				size: albumData.total_size,
			}));
		}
		getTrack();
	}, []);

	const getTrack = () => {
		var config = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("tokenArtist"),
			},
		};
		axios
			.post(
				"/app/trackDextra/gettracks",
				{ album_id: albumData.dalbum_id },
				config
			)
			.then(function (response) {
				if (response.data.data) {
					setState((oldState) => ({
						...oldState,
						core: response.data.data.Core ? response.data.data.Core : [],
						embed: response.data.data.Embed ? response.data.data.Embed : [],
						other: response.data.data.Other ? response.data.data.Other : [],
					}));
				}
			})
			.catch(function (error) {
				//console.log(error);
			});
	};

	return (
		<>
			<div className="row mb30">
				<div className="col-md-7 offset-md-2">
					<div className="dextra-collapse-wrapper" id="accordion1">
						<div className="collpase-list mb20">
							<div className="dextra-collapse-heading bg-green border-white">
								<a
									data-toggle="collapse"
									data-target="#first"
									className="d-block text-white text-uppercase pd20"
								>
									Core Dalbum Tracks
									<i className="fa fa-caret-down pull-right"></i>
								</a>
							</div>
							<div
								id="first"
								className="collapse track-collpapse-content"
								aria-labelledby="ArtworkHeading"
							>
								<ul className="trackExtraList list-unstyled">
									{state.core.map((elem, index) => (
										<li
											style={{ position: "relative" }}
											onClick={() => gotoEdit(1, elem, index)}
										>
											{index + 1}) {elem.name}
											{elem.dextra_labels && elem.dextra_labels.length > 0 ? (
												<>
													<div
														className="option pd10 bg-orange last-option"
														style={{
															position: "absolute",
															right: 0,
															bottom: 0,
														}}
													>
														<div className="add text-center">
															<a className="text-white">
																<img src="data:image/png;base64,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" />
															</a>
														</div>
													</div>
												</>
											) : (
												<>
													<div
														className="option pd10 bg-green last-option"
														style={{
															position: "absolute",
															right: 0,
															bottom: 0,
															height: "100%",
														}}
													>
														<div className="add text-center">
															<a className="text-white">
																<i className="fa fa-plus d-block"></i>Add
															</a>
														</div>
													</div>
												</>
											)}
										</li>
									))}
								</ul>
							</div>
						</div>

						<div className="collpase-list mb20">
							<div className="dextra-collapse-heading bg-green border-white">
								<a
									data-toggle="collapse"
									data-target="#first1"
									className="d-block text-white text-uppercase pd20"
								>
									Embedded Tracks<i className="fa fa-caret-down pull-right"></i>
								</a>
							</div>
							<div
								id="first1"
								className="collapse track-collpapse-content"
								aria-labelledby="ArtworkHeading"
							>
								<ul className="trackExtraList list-unstyled">
									{state.embed.map((elem, index) => (
										<li
											style={{ position: "relative" }}
											onClick={() => gotoEdit(2, elem, index)}
										>
											{elem.name}
											{elem.dextra_labels && elem.dextra_labels.length > 0 ? (
												<>
													<div
														className="option pd10 bg-orange last-option"
														style={{
															position: "absolute",
															right: 0,
															bottom: 0,
														}}
													>
														<div className="add text-center">
															<a className="text-white">
																<img src="data:image/png;base64,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" />
															</a>
														</div>
													</div>
												</>
											) : (
												<>
													<div
														className="option pd10 bg-green last-option"
														style={{
															position: "absolute",
															right: 0,
															bottom: 0,
															height: "100%",
														}}
													>
														<div className="add text-center">
															<a className="text-white">
																<i className="fa fa-plus d-block"></i>Add
															</a>
														</div>
													</div>
												</>
											)}
										</li>
									))}
								</ul>
							</div>
						</div>

						<div className="collpase-list mb20">
							<div className="dextra-collapse-heading bg-green border-white">
								<a
									data-toggle="collapse"
									data-target="#third"
									href="#"
									className="d-block text-white text-uppercase pd20"
								>
									Audio Dextras<i className="fa fa-caret-down pull-right"></i>
								</a>
							</div>
							<div
								id="third"
								className="collapse track-collpapse-content"
								aria-labelledby="third"
							>
								<ul className="trackExtraList list-unstyled">
									{state.other.map((elem, index) => (
										<li
											style={{ position: "relative" }}
											onClick={() => gotoEdit(3, elem, index)}
										>
											{elem.name}

											{elem.dextra_labels && elem.dextra_labels.length > 0 ? (
												<>
													<div
														className="option pd10 bg-orange last-option"
														style={{
															position: "absolute",
															right: 0,
															bottom: 0,
														}}
													>
														<div className="add text-center">
															<a className="text-white">
																<img src="data:image/png;base64,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" />
															</a>
														</div>
													</div>
												</>
											) : (
												<>
													<div
														className="option pd10 bg-green last-option"
														style={{
															position: "absolute",
															right: 0,
															bottom: 0,
															height: "100%",
														}}
													>
														<div className="add text-center">
															<a className="text-white">
																<i className="fa fa-plus d-block"></i>Add
															</a>
														</div>
													</div>
												</>
											)}
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TrackList;
